import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { MeetingProvider } from '@oneboard/meeting';
import { CanvasProvider, WhiteboardProvider } from '@oneboard/whiteboard';
import { DeviceDetectProvider } from '@oneboard/deviceDetect';
// import AuthProvider from 'providers/AuthProvider';
import ThemeProvider from 'providers/ThemeProvider';
import { CourseInfoProvider } from 'providers/CourseInfoProvider';
import { StreamingProvider } from 'providers/StreamingProvider';
import 'antd/dist/antd.css';
import './index.css';
import { TranslationProvider } from './services/translation';
import { MeetingProvider as ChimeMeetingProvider } from 'amazon-chime-sdk-component-library-react';

const meetingConfig = {
  PROJECT_NAME: `oneboard-${process.env.REACT_APP_ENV}`,
  CHIME_API_URL: process.env.REACT_APP_CHIME_API_URL,
  LOG_URL: process.env.REACT_APP_CHIME_LOG_API_URL,
};
const root = document.getElementById('root');
const Main = () => (
  <BrowserRouter>
    <ThemeProvider>
      <WhiteboardProvider>
        <TranslationProvider>
          <ChimeMeetingProvider>
            <MeetingProvider config={meetingConfig}>
              <CanvasProvider>
                <DeviceDetectProvider>
                  <CourseInfoProvider>
                    <StreamingProvider>
                      <App />
                    </StreamingProvider>
                  </CourseInfoProvider>
                </DeviceDetectProvider>
              </CanvasProvider>
            </MeetingProvider>
          </ChimeMeetingProvider>
        </TranslationProvider>
      </WhiteboardProvider>
    </ThemeProvider>
  </BrowserRouter>
);

ReactDOM.render(Main(), root);

reportWebVitals();
